export { DesignSystemProvider, useDesignSystem, } from './components/DesignSystemProvider';
export { ZinniaProvider } from './components/ZinniaProvider/ZinniaProvider';
//# sourceMappingURL=index.js.map
// @zapier/design-system-context@1.4.1 (556986fb1)
